import { rutValidate, rutFormat } from 'rut-helpers';

export default rutFormat;